import React from 'react';
import { Image } from 'react-bootstrap';
import IconBox from '../../../component/global/IconBox';
import {
	attachmentHref,
	isLikelyImageUrl,
} from '../../../utils/mediaUrl';

const SendingPictures = ({ files }) => {
	const items = (files || [])
		.map((file, index) => {
			const href = attachmentHref(file);
			if (!href) return null;
			return { href, index, isImage: isLikelyImageUrl(href) };
		})
		.filter(Boolean);

	return (
		<div className="sending_pictures modal_main_content">
			<div className="pictures_row">
				{items.map(({ href, index, isImage }) => (
					<div className="column" key={index}>
						<div className="pictures_box">
							{isImage ? (
								<Image src={href} className="image" />
							) : (
								<a
									href={href}
									target="_blank"
									rel="noreferrer"
									className="image d-flex align-items-center justify-content-center text-center p-3"
									style={{
										background: '#eef3ff',
										color: '#2e71fc',
										textDecoration: 'none',
										wordBreak: 'break-all',
									}}
								>
									دانلود فایل پیوست
								</a>
							)}
							<IconBox
								iconName="downloadIconBlack"
								specialClass="light_gray_box"
								clickFunction={() => {
									window.open(href, '_blank').focus();
								}}
							/>
						</div>
					</div>
				))}
			</div>
		</div>
	);
};

export default SendingPictures;
